import { Text } from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import FilterRow, { FilterGroup } from '../../reusable/Layout';
import TextInput from '../../reusable/TextInput/TextInput';

const KeywordsSearch = React.memo(({ onFilterValueChange, translations }) => {
  const keyword = useSelector((state) => state.nposFilters.freeText);
  return (
    <FilterGroup>
      <FilterRow>
        <Text className="filter-name">{translations.RL_KeywordsSearch}</Text>
        <Text className="filter-description">{translations.RL_KeywordsSearchDesc}</Text>
      </FilterRow>
      <FilterRow>
        <TextInput
          data-testid="keywords-search-input"
          id="freeText"
          label={translations.RL_SearchLabel}
          placeholder={translations.RL_SearchLabel}
          value={keyword}
          onChange={onFilterValueChange}
          onClear={() => onFilterValueChange({ target: { id: 'freeText', value: '' } })}
        />
      </FilterRow>
    </FilterGroup>
  );
});

KeywordsSearch.propTypes = {
  onFilterValueChange: PropTypes.func.isRequired,
  translations: PropTypes.shape().isRequired,
};

export default KeywordsSearch;
